import { NavLink } from "react-router-dom";
import { House, CalendarBlank, HardHat, FileText, Fire, Truck } from "@phosphor-icons/react";
import useSavUnreadCount from "@/lib/useSavUnreadCount";

const TABS = [
  { to: "/", label: "Accueil", icon: House, testid: "tab-home", end: true },
  { to: "/agenda", label: "Agenda", icon: CalendarBlank, testid: "tab-agenda" },
  { to: "/chantiers", label: "Chantier", icon: HardHat, testid: "tab-chantiers" },
  { to: "/vehicule", label: "Véhicule", icon: Truck, testid: "tab-vehicule" },
  { to: "/alertes", label: "Alertes", icon: Fire, testid: "tab-alertes", badgeKey: "sav" },
  { to: "/documents", label: "Docs", icon: FileText, testid: "tab-documents" },
];

export default function BottomTabBar() {
  const { count: savCount } = useSavUnreadCount();
  return (
    <nav
      data-testid="bottom-tab-bar"
      className="fixed bottom-0 left-0 right-0 z-30 border-t border-white/10 glass-dark pb-safe"
    >
      <div className="max-w-2xl mx-auto grid grid-cols-6 px-2">
        {TABS.map(({ to, label, icon: Icon, testid, end, badgeKey }) => {
          const badge = badgeKey === "sav" ? savCount : 0;
          return (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 py-3 rounded-xl active:scale-95 transition-transform relative ${
                  isActive ? "text-[#005CFF]" : "text-white/50"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <div className="relative">
                    <Icon size={22} weight={isActive ? "fill" : "regular"} />
                    {badge > 0 && (
                      <span
                        className="absolute -top-1 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center animate-pulse"
                        data-testid={`badge-${testid}`}
                      >
                        {badge > 99 ? "99+" : badge}
                      </span>
                    )}
                  </div>
                  <span className={`text-[10px] uppercase tracking-widest ${isActive ? "font-semibold" : ""}`}>
                    {label}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
